export const sanityLinkToAnchor = (sanityLink, brand) => {
  const anchor = {
    href: undefined,
    rel: undefined,
    target: undefined,
  };

  switch (sanityLink?._type) {
    case 'linkExternal':
    case 'linkExternalNoTitle':
    case 'annotationLinkExternal':
      anchor.href = sanityLink?.url;
      if (sanityLink?.newWindow) {
        anchor.rel = 'noreferrer';
        anchor.target = '_blank';
      }
      break;

    case 'linkBlog':
    case 'annotationLinkBlog':
      anchor.href = '/blog';
      if (sanityLink?.blogName?.length) {
        anchor.href += `/${sanityLink.blogName}`;
      } else if (brand.name?.length) {
        anchor.href += `/${brand.name}-blog`;
      }
      if (sanityLink?.url?.length) anchor.href += `/${sanityLink.url}`;
      break;

    case 'linkInternal':
    case 'annotationLinkInternal':
      anchor.href = sanityLink?.reference?.slug;
      break;

    default:
      break;
  }

  return anchor;
};
